import { AppConfig } from '@/config/app.config';
import { authService } from '@/services/auth.service';

class LoginService {
  /** GS-900: an operator session where sign-in is required; always "yes" where it is not (the legacy SES). */
  public async isLoggedn(): Promise<boolean> {
    return !AppConfig.requireSignin || authService.isSignedIn();
  }
}
// Export singltone instance
export const loginService = new LoginService();